export const introArea = {
  title1:
    "En <span>MANTIZ</span> nos aseguramos de la <span>Calidad</span>, esto para poder cubrir realmente la <span>necesidad del Cliente</span>, mejorando la <span>Experiencia de los Usuarios</span>  que intervienen en los Procesos.",
  title2:
    "Proporciona toda la funcionalidad que su Empresa necesita para Automatizar los procesos más complejos, con una baja dependencia de recursos técnicos especializados",
}
